// import DataProtection from "../../Artifacts/Home/DataProtection.gif";
// import Mobile from "../../Artifacts/Home/MobileCompatibility.gif";
// import Realtime from "../../Artifacts/Home/RealtimeAnalytics 2.gif";
// import Truck2 from "../../Artifacts/Home/TruckWithGuy.svg";
// import Truck1 from "../../Artifacts/Home/TruckwithDealer-SVG.svg";

// import total_retail from "../../Artifacts/Home/total retail.svg";
// import total_stock from "../../Artifacts/Home/total stock.svg";
// import total_offtake from "../../Artifacts//Home/total offtake.svg";
// import pipeline from "../../Artifacts/Home/pipeline.svg";
// import conversion from "../../Artifacts/Home/conversion.svg";

// import { MetricBox } from "../../Components/KPI/HomeMetric";
// import { GifSection } from "../../Components/KPI/HomeGifs";
// import { useQuery } from "@tanstack/react-query";
// import { useSelector } from "react-redux";

// import {
//   landing_retails,
//   offtake_retails,
//   stock_retails,
//   tqp_retails,
//   conv_retails,
//   marquee_message,
// } from "./HomeApi";

// const Landing = () => {
//   const sections = [
//     {
//       title: "REALTIME ANALYTICS",
//       src: Realtime,
//       alt: "Realtime Analytics",
//       height: "h-[120px]",
//       width: "w-[140px]",
//     },
//     {
//       title: "DATA PROTECTION",
//       src: DataProtection,
//       alt: "Data Protection",
//       height: "h-[120px]",
//       width: "w-[140px]",
//     },
//     {
//       title: "MOBILE COMPATIBLE",
//       src: Mobile,
//       alt: "Mobile Compatible",
//       height: "h-[80px]",
//       width: "w-[140px]",
//     },
//   ];

//   const { data, submitted } = useSelector((state) => state.filtersOfftake);

//   const { data: landing_data } = useQuery({
//     queryKey: ["landing_retails", submitted],
//     queryFn: () => landing_retails(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const { data: offtake_data } = useQuery({
//     queryKey: ["offtake_retails", submitted],
//     queryFn: () => offtake_retails(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const { data: tqp_data } = useQuery({
//     queryKey: ["tqp_retails", submitted],
//     queryFn: () => tqp_retails(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const { data: stock_data } = useQuery({
//     queryKey: ["stock_retails", submitted],
//     queryFn: () => stock_retails(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const { data: conv_data } = useQuery({
//     queryKey: ["conv_retails", submitted],
//     queryFn: () => conv_retails(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const { data: marqueeData } = useQuery({
//     queryKey: ["marquee_message", submitted],
//     queryFn: () => marquee_message(data),
//     initialData: {},
//     refetchInterval: 300000,
//     refetchIntervalInBackground: true,
//   });

//   const marqueeText =
//     typeof marqueeData?.marquee_msg === "string"
//       ? marqueeData.marquee_msg.trim()
//       : "";

//   return (
//     <div className="flex flex-col flex-grow relative">
//       {/* ================= MARQUEE ================= */}
//       {marqueeText && (
//         <>
//           <div className="w-full    overflow-hidden h-6 flex items-center">
//             <div className="whitespace-nowrap animate-marquee text-[#2A5775] text-sm font-medium px-4">
//               {marqueeText}
//             </div>
//           </div>
//         </>
//       )}

//       {/* ================= MAIN CONTENT ================= */}
//       <div className="flex h-full w-full pt-2 px-5 pb-1 gap-3">
//         <GifSection data={sections} />

//         <div className="md:flex items-center relative block">
//           <img
//             src={Truck2}
//             alt="Truck"
//             className="w-[465px] h-[465px] object-cover hidden sm:block"
//           />
//           <img
//             src={Truck1}
//             alt="Truck Mobile"
//             className="w-[400px] h-[300px] object-cover block sm:hidden"
//           />

//           <div className="md:absolute md:top-0 right-0">
//             <MetricBox
//               title="Total Retail"
//               targetValue={landing_data?.Total_Retail || 0}
//               description="ARN with Maximum number of Retail :"
//               des_value={landing_data?.Maximum_count_of_invoice_arn || "NA"}
//               position="lg:-right-[90%] top-[10px]"
//               image={total_retail}
//             />
//             <MetricBox
//               title="Total Offtake"
//               targetValue={offtake_data?.Total_Offtake || 0}
//               description="PL with Maximum Offtake :"
//               des_value={offtake_data?.PL_with_maximum_offtake || "NA"}
//               position="lg:-right-[108%] top-[30px]"
//               image={total_offtake}
//             />
//             <MetricBox
//               title="Total Stock"
//               targetValue={stock_data?.Total_Stock || 0}
//               description="Dealer with Maximum Stock :"
//               des_value={stock_data?.Dealer_with_maximum_stock || "NA"}
//               position="lg:-right-[113%] top-[65px]"
//               image={total_stock}
//             />
//             <MetricBox
//               title="C0 to Retail Conversion (Days)"
//               targetValue={conv_data?.AVG_conversion_days || 0}
//               description="Dealer with Fastest Conversion :"
//               des_value={conv_data?.top_dealer_in_retail_conversion || "NA"}
//               position="lg:-right-[108%] top-[93px]"
//               image={conversion}
//             />
//             <MetricBox
//               title="TQP"
//               targetValue={tqp_data?.Total_TQP || 0}
//               description="PL with Highest TQP :"
//               des_value={tqp_data?.PL_with_highest_TQP || "NA"}
//               position="lg:-right-[91%] top-[130px]"
//               image={pipeline}
//             />
//           </div>
//         </div>
//       </div>

//       {/* ================= FLOATING RELEASE NOTES ================= */}
//       {/* <div className="fixed bottom-5 right-5 z-50 group">
//         <div className="bg-[#2A5775] text-white px-4 py-2 rounded-full shadow-lg cursor-pointer text-sm font-medium">
//           🚀 What’s New
//         </div>

//         <div className="absolute bottom-12 right-0 w-[320px] bg-white rounded-xl shadow-2xl border opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-200">
//           <div className="p-4">
//             <h3 className="text-sm font-semibold text-[#2A5775] mb-3">
//               Release Notes
//             </h3>

//             <div className="space-y-4 text-sm text-gray-600">
//               <div>
//                 <div className="font-semibold text-gray-800">
//                   v2.4.0{" "}
//                   <span className="text-xs text-gray-400">(Feb 2026)</span>
//                 </div>
//                 <ul className="list-disc list-inside">
//                   <li>Improved realtime analytics</li>
//                   <li>Enhanced TQP pipeline</li>
//                   <li>KPI accuracy improvements</li>
//                 </ul>
//               </div>

//               <div>
//                 <div className="font-semibold text-gray-800">
//                   v2.3.5{" "}
//                   <span className="text-xs text-gray-400">(Jan 2026)</span>
//                 </div>
//                 <ul className="list-disc list-inside">
//                   <li>Stock reconciliation fixes</li>
//                   <li>Performance optimizations</li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div> */}

//       {/* ================= MARQUEE ANIMATION ================= */}
//       <style>
//         {`
//           @keyframes marquee {
//             0% { transform: translateX(100%); }
//             100% { transform: translateX(-100%); }
//           }
//           .animate-marquee {
//             animation: marquee 18s linear infinite;
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default Landing;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Truck2 from "../../Artifacts/Home/TruckwithDealer-SVG.svg";
import Trucksidebar from "../../Artifacts/trucksidebar.svg";

import background from "../../Artifacts/TruckwithDealer.svg";
import line1 from "../../Artifacts/line1.svg";
import line2 from "../../Artifacts/line2.svg";

import icon1 from "../../Artifacts/icon1.svg";
import icon2 from "../../Artifacts/icon2.svg";
import icon3 from "../../Artifacts/icon3.svg";
import icon4 from "../../Artifacts/icon4.svg";
import icon5 from "../../Artifacts/icon5.svg";
import icon6 from "../../Artifacts/icon6.svg";
import icon7 from "../../Artifacts/icon7.svg";
import icon8 from "../../Artifacts/icon8.svg";
import horn_img from "../../Artifacts/Home/horn_img.svg";
import { useQuery } from "@tanstack/react-query";
import redirection from "../../Artifacts/redirecticon.svg";
import {
  landing_retails,
  offtake_retails,
  stock_retails,
  tqp_retails,
  conv_retails,
  marquee_message,
  free_service,
  total_revenue,
  service_penetration,
} from "./HomeApi";

import logohomepage from "../../Artifacts/Home/logohomepage.svg";
import { useSelector } from "react-redux";

// Metric Card
// TODO: Test this function
const MetricCard = ({ metric, icon, side, isMobile = false }) => {
  const isRight = side === "right" && !isMobile;
  const navigate = useNavigate();

  return (
    <div
      onClick={() => metric.route && navigate(metric.route)}
      className={`relative flex items-center gap-2 bg-white bg-opacity-80 backdrop-blur-sm shadow-md border border-white border-opacity-40 hover:scale-105 hover:shadow-xl transition-all duration-200 cursor-pointer ${
        isMobile
          ? "w-full px-2 py-3 rounded-2xl"
          : "px-3 py-1 rounded-3xl gap-3"
      }`}
      style={{
        width: isMobile ? "auto" : 230,
        // flexDirection: isRight ? "row-reverse" : "row",
        flexDirection: isRight ? "row" : "row",

        minHeight: isMobile ? "64px" : "auto",
      }}
    >
      {metric.tag && (
        <span
          className={`absolute ${isMobile ? "top-1 left-3 text-[7px]" : "top-1 left-4 text-[8px]"} font-bold text-black uppercase mb-1 tracking-wider`}
        >
          {metric.tag}
        </span>
      )}
      <div
        className={`flex-shrink-0 rounded-full flex mt-2 items-center justify-center shadow-sm ${
          isMobile ? "w-8 h-8" : "w-11 h-11"
        }`}
        style={{ background: "linear-gradient(135deg, #6FA480, #2D7D91)" }}
      >
        <img src={icon} alt="" className={isMobile ? "w-4 h-4" : "w-6 h-6"} />
      </div>

      <div
        className={`flex flex-col min-w-0 w-full ${
          isRight ? "items-start text-left" : "items-start text-left"
        }`}
      >
        <div className="flex justify-between items-center w-full">
          <span
            className={`${isMobile ? "text-sm" : "text-base"} font-extrabold text-gray-900 leading-tight tracking-tight`}
          >
            {metric.value}
          </span>
          <img src={redirection} className="h-4 w-4" />
        </div>
        <span
          className={`${isMobile ? "text-[10px]" : "text-xs"} font-semibold text-gray-700 leading-snug truncate w-full`}
          title={metric.label}
        >
          {metric.label}
        </span>
        <span
          className="text-[9px] text-gray-600 leading-tight mt-0.5 truncate w-full"
          title={metric.sub}
        >
          {metric.sub}
        </span>
        <span
          className="text-[8px] text-gray-500 font-medium leading-tight truncate w-full"
          title={metric.dealer}
        >
          {metric.dealer}
        </span>
      </div>
    </div>
  );
};

export default function Dealer360Dashboard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, submitted } = useSelector((state) => state.filtersOfftake);

  const { data: landing_data } = useQuery({
    queryKey: ["landing_retails", submitted],
    queryFn: () => landing_retails(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: offtake_data } = useQuery({
    queryKey: ["offtake_retails", submitted],
    queryFn: () => offtake_retails(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: tqp_data } = useQuery({
    queryKey: ["tqp_retails", submitted],
    queryFn: () => tqp_retails(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: stock_data } = useQuery({
    queryKey: ["stock_retails", submitted],
    queryFn: () => stock_retails(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: conv_data } = useQuery({
    queryKey: ["conv_retails", submitted],
    queryFn: () => conv_retails(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: freeservice_data } = useQuery({
    queryKey: ["free_hitsfreeservice_data", submitted],
    queryFn: () => free_service(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  const { data: totalrevenue } = useQuery({
    queryKey: ["total_revenue", submitted],
    queryFn: () => total_revenue(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });
  const { data: servicerevenue } = useQuery({
    queryKey: ["service_penetraion", submitted],
    queryFn: () => service_penetration(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: marqueeData } = useQuery({
    queryKey: ["marquee_message", submitted],
    queryFn: () => marquee_message(data),
    initialData: {},
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const leftMetrics = [
    {
      id: 1,
      value: landing_data?.Total_Retail || 0,
      label: "Total Retail",
      sub: "ARN with Max No. of Retail:",
      dealer: landing_data?.Maximum_count_of_invoice_arn || "NA",
      route: "/Retail-Dashboard",
    },
    {
      id: 2,
      value: offtake_data?.Total_Offtake || 0,
      label: "Total Offtake",
      sub: "PL With Max Offtake",
      dealer: offtake_data?.PL_with_maximum_offtake || "NA",
      route: "/Offtake-Dashboard",
    },
    {
      id: 3,
      value: stock_data?.Total_Stock || 0,
      label: "Total Stock",
      sub: "PL With Max Offtake",
      dealer: stock_data?.Dealer_with_maximum_stock || "NA",
      route: "/Stock-Dashboard",
    },
    {
      id: 4,
      value: conv_data?.AVG_conversion_days || 0,
      label: "C0 To Retail Conv.",
      sub: "ARN with Max No. of Retail:",
      dealer: conv_data?.top_dealer_in_retail_conversion || "NA",
      route: "/Pipeline",
    },
  ];

  const rightMetrics = [
    {
      id: 5,
      value: tqp_data?.Total_TQP || 0,
      label: "TQP",
      sub: "PL With Max Offtake",
      dealer: tqp_data?.PL_with_highest_TQP || "NA",
      route: "/Pipeline",
    },
    {
      id: 6,
      value: (servicerevenue?.revenue || 0) + "%",
      label: "Service Revenue Penetration",
      tag: "SCV&PU",
      sub: "Current Month ",
      dealer: servicerevenue?.month
        ? `${servicerevenue?.month} ${servicerevenue?.year ?? ""}`.trim()
        : "NA",
      route: "/Service-Collabax",
    },
    {
      id: 7,
      value: totalrevenue?.revenue
        ? (totalrevenue.revenue / 10000000).toFixed(2) + " Cr"
        : "0.00 Cr",
      label: "Total Revenue",
      tag: "SCV&PU",
      sub: "Current Month",
      dealer: totalrevenue?.month
        ? `${totalrevenue?.month} ${totalrevenue?.year ?? ""}`.trim()
        : "NA",
      route: "/Service-Collabax",
    },
    {
      id: 8,
      value: (freeservice_data?.revenue || 0) + "%",
      label: "Free Service Hit Rate",
      tag: "SCV&PU",
      sub: "Current Month",
      dealer: freeservice_data?.month
        ? `${freeservice_data?.month} ${freeservice_data?.year ?? ""}`.trim()
        : "NA",
      route: "/Service-Collabax",
    },
  ];

  const leftIcons = [icon1, icon2, icon3, icon4];
  const rightIcons = [icon5, icon6, icon7, icon8];

  // In Image 2, cards arc outward: top cards shift UP & slightly out,
  // bottom cards shift DOWN & slightly out, middle cards are closer
  // Left side: top card is high-left, bottom card is low-left
  // Each card also has a vertical offset to arc them
  const leftPositions = [
    { x: 0, y: 0 }, // top
    { x: -12, y: 8 }, // upper-mid - slightly further left & down
    { x: -12, y: 16 }, // Lower-mid
    { x: 0, y: 24 }, // bottom
  ];

  const rightPositions = [
    { x: 0, y: 0 },
    { x: 12, y: 8 },
    { x: 12, y: 16 },
    { x: 0, y: 24 },
  ];

  return (
    <div
      style={{ fontFamily: "'Segoe UI', sans-serif" }}
      className="relative flex flex-col flex-1 w-full h-full min-h-full overflow-hidden bg-[#F3F7FA] lg:bg-transparent"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed pointer-events-none"
        style={{ backgroundImage: `url(${background})` }}
      />
      {/* Tint overlay */}
      <div className="absolute inset-0 pointer-events-none" />

      {/* ----------- DESKTOP VIEW ----------- */}
      <div className="hidden lg:flex relative flex-col w-full h-full">
        {/* TOP: Tata Motors Dealer 360° Title */}
        <div className="flex items-center justify-center  pt-4 pb-1">
          <div className="flex flex-col items-center">
            <img src={logohomepage} className="h-12 w-96" />
          </div>
        </div>

        {/* MIDDLE: Three-column Layout */}
        <div
          className="flex flex-1 items-center justify-between pr-4 pb-0"
          style={{ minHeight: 0 }}
        >
          {/* LEFT COLUMN: Cards with Line1 behind */}
          <div
            className="relative flex items-center justify-end"
            style={{ width: 290, alignSelf: "stretch" }}
          >
            {/* Curved spine Line */}
            <img
              src={line1}
              alt=""
              className="absolute left-64 -top-12 h-full w-auto object-contain object-right pointer-events-none select-none"
              style={{ maxWidth: 350, height: 408 }}
            />
            {/* cards stacked with arc offsets */}
            <div className="relative left-24 flex flex-col justify-around h-full py-2 w-full pr-6">
              {leftMetrics.map((m, i) => (
                <div
                  key={m.id}
                  style={{
                    transform: `translateX(${leftPositions[i].x}px)`,
                  }}
                >
                  <MetricCard metric={m} icon={leftIcons[i]} side="left" />
                </div>
              ))}
            </div>
          </div>

          {/* CENTER: Truck image */}
          <div className="flex-1 flex flex-col items-center justify-end pb-2 pointer-events-none select-none">
            <img
              src={Truck2}
              alt="Tata Truck with Dealer"
              className="w-full object-contain drop-shadow-2xl"
              style={{ maxWidth: 608, maxHeight: "64vh" }}
            />
          </div>

          {/* RIGHT COLUMN: Cards with Line2 behind */}
          <div
            className="relative flex items-center justify-start"
            style={{ width: 290, alignSelf: "stretch" }}
          >
            {/* Curved spine Line */}
            <img
              src={line2}
              alt=""
              className="absolute right-64 -top-12 h-full w-auto object-contain object-left pointer-events-none select-none"
              style={{ maxWidth: 300, height: 408 }}
            />

            {/* Cards stacked with arc offsets */}
            <div className="relative right-24 flex flex-col justify-around h-full py-3 w-full pl-6 items-end">
              {rightMetrics.map((m, i) => (
                <div
                  key={m.id}
                  style={{
                    transform: `translateX(${rightPositions[i].x}px)`,
                  }}
                >
                  <MetricCard metric={m} icon={rightIcons[i]} side="right" />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* BOTTOM: Collabx AI Assistant Banner */}
        <div className="flex justify-center -translate-y-4 translate-x-3 ">
          <div
            className="relative flex items-center gap-4 bg-white/20 backdrop-blur-md rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.1)] px-5 py-2 border border-white/30"
            style={{ width: 350 }}
          >
            <div className="absolute -top-3 -left-2 bg-gradient-to-r from-red-600 to-red-500 text-white text-xs font-black px-3 py-1 rounded-lg -rotate-12 shadow-md">
              What's New
            </div>
            {/* Megaphone Icon */}
            <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
              <img
                src={horn_img}
                alt="Horn"
                className="w-full h-full object-contain drop-shadow"
              />
            </div>
            <div className="flex flex-col flex-1 min-w-0">
              <span className="font-extrabold text-xs text-blue-900">
                Collabx AI Assistant
              </span>
              <span className="text-xs text-gray-500">
                Instant Fleet &amp; Performance Insights
              </span>
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-1 bg-white/60 backdrop-blur-sm border border-white/80 text-blue-900 text-xs font-bold px-4 py-2 rounded-xl shadow-sm hover:scale-105 active:scale-95 transition-transform duration-150 flex-shrink-0"
            >
              More Details
              <svg viewBox="0 0 16 16" fill="none" className="w-3.5 h-3.5">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* ----------- MOBILE VIEW ----------- */}
      <div className="flex lg:hidden relative flex-col w-full h-full overflow-y-auto overflow-x-hidden pb-8 items-center justify-start">
        {/* Truck Image */}
        <div className="w-full flex justify-center mt-2 px-4 relative shrink-0 pointer-events-none select-none">
          <img
            src={Truck2}
            alt="Tata Truck with Dealer"
            className="w-full max-w-[400px] object-contain drop-shadow-xl relative shrink-0"
          />
        </div>

        {/* Logo */}
        <div className="flex justify-center mt-6 mb-6 shrink-0 relative">
          <img
            src={logohomepage}
            className="h-10 sm:h-12 w-auto relative"
            alt="Logo"
          />
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-2 gap-3 px-3 sm:px-6 w-full max-w-lg mb-8 shrink-0">
          <MetricCard
            metric={leftMetrics[0]}
            icon={leftIcons[0]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={leftMetrics[1]}
            icon={leftIcons[1]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={leftMetrics[2]}
            icon={leftIcons[2]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={rightMetrics[2]}
            icon={rightIcons[2]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={leftMetrics[3]}
            icon={leftIcons[3]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={rightMetrics[1]}
            icon={rightIcons[1]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={rightMetrics[0]}
            icon={rightIcons[0]}
            side="left"
            isMobile
          />
          <MetricCard
            metric={rightMetrics[3]}
            icon={rightIcons[3]}
            side="left"
            isMobile
          />
        </div>

        {/* Bottom Banner */}
        <div className="w-full px-4 flex justify-center mt-auto shrink-0 pt-4">
          <div
            className="relative flex items-center gap-2 sm:gap-4 bg-white/20 backdrop-blur-md rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.1)] px-4 py-2 border border-white/30"
            style={{ width: "100%", maxWidth: 350 }}
          >
            <div className="absolute -top-3 -left-2 bg-gradient-to-r from-red-600 to-red-500 text-white text-[10px] sm:text-xs font-black px-2 py-1 rounded-lg -rotate-12 shadow-md">
              What's New
            </div>
            {/* Megaphone Icon */}
            <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center flex-shrink-0">
              <img
                src={horn_img}
                alt="Horn"
                className="w-full h-full object-contain drop-shadow"
              />
            </div>
            <div className="flex flex-col flex-1 min-w-0">
              <span className="font-extrabold text-[11px] sm:text-xs text-blue-900 truncate">
                Collabx AI Assistant
              </span>
              <span className="text-[9px] sm:text-xs text-gray-500 truncate">
                Instant Fleet &amp; Performance Insights
              </span>
            </div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="flex items-center gap-1 bg-white/60 backdrop-blur-sm border border-white/80 text-blue-900 text-[10px] sm:text-xs font-bold px-2 sm:px-4 py-1.5 sm:py-2 rounded-xl shadow-sm hover:scale-105 active:scale-95 transition-transform duration-150 flex-shrink-0"
            >
              Try Now
              <svg
                viewBox="0 0 16 16"
                fill="none"
                className="w-3 h-3 sm:w-3.5 sm:h-3.5"
              >
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-md">
          <div className="bg-white/40 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/60 p-6 w-[320px] relative flex flex-col items-center">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition-colors"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-5 h-5"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <div className="w-12 h-12 rounded-full bg-white/60 border border-white/50 shadow-sm flex items-center justify-center mb-4">
              <span className="text-xl drop-shadow-sm">✨</span>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2 drop-shadow-sm">
              What's New
            </h3>
            <p
              className="text-sm font-semibold text-center text-gray-800 drop-shadow-sm"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {marqueeData?.marquee_msg ||
                "NFA Feature implement in Realizaion dashboard"}
            </p>
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-6 w-full bg-blue-600/90 hover:bg-blue-600 text-white py-2 rounded-xl text-sm font-bold shadow-lg backdrop-blur-md transition-all border border-blue-400/50"
            >
              Got it!
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
